var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23655 9.92205e-05L5.33926 0.0114316L11.1453 1.17839C11.3827 1.22613 11.562 1.41543 11.6031 1.64834L11.612 1.75054V12.2495C11.612 12.4929 11.4624 12.7066 11.2433 12.7928L11.1453 12.8217L5.33926 13.9887C5.16869 14.023 4.99182 13.9785 4.8573 13.8678C4.74968 13.7791 4.67825 13.6554 4.65398 13.5199L4.64479 13.4165V0.583578L4.65398 0.480168C4.67825 0.344731 4.74968 0.221012 4.8573 0.132352C4.96491 0.0436908 5.09963 -0.00243668 5.23655 9.92205e-05ZM3.48359 1.16706V2.33402H1.1612V11.6661H3.48359V12.833H0.580599C0.295574 12.833 0.0585151 12.6266 0.00935425 12.3544L0 12.2495V1.75054C0 1.4641 0.205389 1.22586 0.476236 1.17646L0.580599 1.16706H3.48359ZM5.80599 1.29532V12.7048L10.4508 11.7712V2.22889L5.80599 1.29532ZM7.54779 6.41651C7.86844 6.41651 8.12839 6.67775 8.12839 6.99999C8.12839 7.32225 7.86844 7.58347 7.54779 7.58347C7.22713 7.58347 6.96719 7.32225 6.96719 6.99999C6.96719 6.67775 7.22713 6.41651 7.54779 6.41651Z",
    fill: "#F9F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDoor);
export default __webpack_public_path__ + "static/media/Open-Door.c33458ca7201cccbecaeb5e7618518fb.svg";
export { ForwardRef as ReactComponent };